import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-heading text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-heart-3-fill text-primary-500 text-2xl"></i>
            </div>
            <span>萌白酱</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
              }`}
            >
              关于萌白酱
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-fade-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line mr-2"></i>
              关于萌白酱
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}